import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  menuOptionParent: {
   
    "& .MuiAutocomplete-listbox": {
      "& .MuiCheckbox-root": {
        marginRight: "0 !important",
      },
      "& li > div": {
        display: "flex !important",
        alignItems: "center !important",
      },
    },
    "& .MuiAutocomplete-option": {
      padding: "4px 0px",
    },
  },
   switch: {
    marginLeft: 10,
    whiteSpace: 'nowrap', // Default to nowrap for larger screens
  },
  customAutocomplete: {
    minWidth: "302px",
    maxWidth: "302px",
    "& .MuiAutocomplete-endAdornment": {
      display: "flex",
      alignItems: "center",
      borderRadius: "4px",
      height: "100%",
      right: "0px !important",
      top: "0px !important",
      background:
        "linear-gradient(90deg, rgba(42, 123, 155, 0) 0%, rgba(255, 255, 255, 0.85) 15%, rgba(255, 255, 255, 1) 100%)",
      padding: "8px 8px 8px 0px !important",
    },
    "& .MuiAutocomplete-clearIndicator": {
      position: "relative",
      "&:hover": {
        backgroundColor: "transparent !important",
      },
    },
    "& .MuiAutocomplete-popupIndicator": {
      borderRadius: "50%",
    },
    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      padding: "8px 12px !important",
    },
  },
  menuOption: {
    width: "100%",
  },
  checkBoxIcon: {
    padding: "9px",
    "&.Mui-checked": {
      "& .MuiSvgIcon-root": {
        fill: "#2196F3 !important",
      },
    },
  },
  chipBox: {
    marginLeft: "-5px",
    paddingBottom: "7px",
    height: "100%",
    width: "90%",
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    overflow: "hidden",
    "& .chip": {
      width: "min-content !important",
      display: "flex",
      padding: "3px 4px",
      gap: "6px",
      minHeight: "24px",
      maxHeight: "24px",
      borderRadius: "100px",
      background: "rgba(0, 0, 0, 0.08)",
      color: "rgba(0, 0, 0, 0.87)",
      fontFamily: "Inter",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "0.16px",
      "& .MuiChip-deleteIcon": {
        width: "13.333px",
        height: "13.333px",
        flexShrink: "0",
      },
    },
    "& .MuiChip-label": {
      padding: "0 6px",
    },
  },
}));
